import { useRef, useState } from 'react'

import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { RECEIPT_STATE, SUCURSAL_ORIGEN } from 'Constants'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const ExportReceipt = (props) => {
  const { onClose, open } = props
  const createDismissableSnackbar = useCustomSnackbar()
  const [loading, setLoading] = useState(false)

  const ref = useRef(null)

  const handleSubmit = () => {
    ref.current.click()
  }

  const today = new Date()

  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  async function onSubmit(values) {
    setLoading(true)
    const body = {
      origen: values.origen,
      fecha_inicial: formatDate(values.fecha_inicial),
      fecha_final: formatDate(values.fecha_final),
      estado: values.estado,
    }
    await interfaces.salesReceipt
      .exportReceipt(body)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('Pedidos exportados!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const fields = (setFieldValue) => [
    {
      class: 'custom',
      sm: 12,
      xs: 12,
      component: (
        <FormikAutocomplete
          defaultValue={{ id: 1, label: 'ECO' }}
          label="Origen"
          name="origen"
          options={SUCURSAL_ORIGEN}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value.id)
          }}
        />
      ),
    },
    {
      class: 'datepicker',
      label: 'Fecha desde',
      format: 'dd-MM-yyyy',
      name: 'fecha_inicial',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha hasta',
      format: 'dd-MM-yyyy',
      name: 'fecha_final',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      sm: 12,
      xs: 12,
      component: (
        <FormikAutocomplete
          label="Estado"
          name="estado"
          options={RECEIPT_STATE}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('estado', value.id)
          }}
        />
      ),
    },
  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Exportar recibos"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
          submitText="Confirmar"
        />
      }
      children={
        <Formik
          initialValues={{
            origen: 1,
            fecha_inicial: today,
            fecha_final: today,
            estado: null,
          }}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue, values)}
                spacing={1}
                setFieldValue={setFieldValue}
              />
              <button style={{ display: 'none' }} ref={ref} type="submit" />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportReceipt
